import { makeStyles } from '@fluentui/react-components';

export const useCellSectionDecoratorStyle = makeStyles({
  dragPreview: {
    width: '100px',
    height: '100px',
    display: 'block',
    position: 'relative',
  },
  dragPreviewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    opacity: 0.5,
  },
  dragPreviewFolderWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dragPreviewFolder: {
    width: '100px',
    height: '76px',
  },
  dragPreviewCount: {
    position: 'absolute',
    top: 0,
    left: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
    width: '100px',
    height: '100px',
    lineHeight: '100px',
    backgroundColor: 'rgba(0,0,0,0.5)',
    color: 'white',
    fontSize: '14px',
  },
});
